
import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe, ViewportScroller } from '@angular/common';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { RaiseRefundRequestComponent } from '../raise-refund-request/raise-refund-request.component';
import { PaymentService } from 'src/app/_services/payment.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Location } from '@angular/common';
import { RefundService } from 'src/app/_services/refund.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CancelRefundComponent } from '../cancelRefund/cancel-refund/cancel-refund.component';
import { AuthService } from 'src/app/_services/auth.service';
import { MatSort } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { RefundRequestDetailsComponent } from '../refund-request-details/refund-request-details.component';
import { CommonService } from 'src/app/_services/common.service';
import { Subscription } from 'rxjs';

export interface RemittanceResponse {
  formattedRemittedDate: any,
  completionDate: any,
  numberOfOrders: any,
  refundAmount: any,
  actualSettlementAmount: any,
  remittance: any,
  remittedPayments?: RemittedPayments[] | MatTableDataSource<RemittedPayments>;
}
export interface RemittedPayments {
  loanNumber: any,
  borrower: any,
  propertyAddress: any,
  partyName: any,
  orderDate: any,
  remittanceDate: any,
  refundAmount: any,
  formattedActualSettlementAmount: any,
  formattedRemittanceAmount: any
}

@Component({
  selector: 'app-transaction-detail-page',
  templateUrl: './transaction-detail-page.component.html',
  styleUrls: ['./transaction-detail-page.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
  providers: [DatePipe]
})
export class TransactionDetailPageComponent implements OnInit {

  constructor(private scroller: ViewportScroller, public router: Router,
    public dialog: MatDialog,
    public paymentService: PaymentService,
    private cd: ChangeDetectorRef,
    public refundService: RefundService,
    public authService: AuthService,
    public commonService: CommonService,
    public route: ActivatedRoute,
    public datePipe: DatePipe,
    private location: Location
  ) {
  }

  isRefund: any;
  isCancelled: any;
  refundAttempts: any;
  remitApiResponse: RemittanceResponse[] = [];
  remitData: RemittanceResponse[] = []
  refundData: any = [];
  tableData: any[] = [];
  refundAmt: [] = [];
  refundAmount: [] = [];
  totalAmount: any;
  afsTransactionId: any;
  pageIndex: number = 0;
  pageSize: number = 5;
  totalCount: number = 0;
  isLoading: boolean = false;
  date = new Date();
  expandedRemit: RemittanceResponse | null;
  customerId = this.authService.getRegistredUserDetails().customerId;
  firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  lastDay = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
  subscription: Subscription;

  @ViewChild('refund') refund: MatPaginator;
  @ViewChild('remit') remit: MatPaginator;
  @ViewChild('remitPaginator', { static: true }) remitPaginator: MatPaginator
  @ViewChildren('innerRemitTables') innerRemitTables: QueryList<MatTable<RemittedPayments>>;
  @ViewChildren('innerRemitSort') innerRemitSort: QueryList<MatSort>;
  @ViewChild('outerRemitsort', { static: true }) Remitsort: MatSort;

  ngOnInit(): void {
    this.subscription = this.commonService.refreshGrid$.subscribe((refresh) => {
      if (refresh) {
        this.getRefundByid();
      }
    });
    this.onRemittanceSearch();
    this.getPaymentDetailsByID();
  }

  displayedColumns: string[] = ['srNo', 'refundReqOn', 'transRefNo', 'refundAmount', 'refundStatus', 'cancel'];
  displayedRemittanceParentColumns: string[] = ['formattedRemittedDate', 'completionDate', 'numberOfOrders', 'refundAmount', 'actualSettlementAmount', 'remittance'];
  displayedRemittanceChildColumns: string[] = ['loanNumber', 'borrower', 'propertyAddress', 'partyName', 'orderDate', 'remittanceDate', 'refundAmount', 'formattedActualSettlementAmount', 'formattedRemittanceAmount'];
  remitDataSource: MatTableDataSource<RemittanceResponse>;
  dataSource = new MatTableDataSource(this.refundData);

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  transactionDetailsForm: FormGroup = new FormGroup(
    {
      serviceType: new FormControl(''),
      lender: new FormControl(''),
      loanNum: new FormControl(''),
      trackingNum: new FormControl(''),
      borrower: new FormControl(''),
      property: new FormControl(''),
      serviceItems: new FormControl(''),
      serviceCharge: new FormControl(''),
      ActualSettlement: new FormControl(''),
      orderDate: new FormControl(''),
      settleDate: new FormControl(''),
      completionDate: new FormControl(''),
      cancelDate: new FormControl(''),
      refund: new FormControl(''),
      refundDate: new FormControl(''),
      remitDate: new FormControl(''),
      afsPaymentStatus: new FormControl('')
    }
  )

  //refund
  refundRequestForm: FormGroup = new FormGroup(
    {
      CustTrackingNo: new FormControl(),
      AFSTransactionId: new FormControl(),
      AgentId: new FormControl(''),
      RefundAmount: new FormControl(''),
      ReasonCode: new FormControl(''),
      RefundDate: new FormControl(new Date()),
      Comment: new FormControl(''),
      SendRequestedNotification: new FormControl(true),
      SendProcessedNotification: new FormControl(true),
      ServiceItems: new FormControl([]),
      RefundServiceItems: new FormControl([]),
      CustomerId: new FormControl(''),
      RefundRequestGUID: new FormControl(this.commonService.generate_uuidv4())
    })

  //remittance
  paymentRemittanceForm: FormGroup = new FormGroup({
    fromRemit: new FormControl(this.firstDay),
    toRemit: new FormControl(this.lastDay),
    vendorRemit: new FormControl('ALLVENDORS'),
    lendorRemit: new FormControl(''),
    paymentStatusId: new FormControl(19),
    internalVendorId: new FormControl('')
  })

  openDialog(): void {
    const dialogRef = this.dialog.open(RaiseRefundRequestComponent, {
      width: '550px',
      height: 'auto',
      disableClose: true,
      data: {
        CustTrackingNo: this.refundRequestForm.value.CustTrackingNo,
        AFSTransactionId: this.refundRequestForm.value.AFSTransactionId,
        AgentId: this.refundRequestForm.value.AgentId,
        RefundAmount: this.refundRequestForm.value.RefundAmount,
        ReasonCode: this.refundRequestForm.value.ReasonCode,
        RefundDate: this.refundRequestForm.value.RefundDate,
        SendRequestedNotification: this.refundRequestForm.value.SendRequestedNotification,
        SendProcessedNotification: this.refundRequestForm.value.SendProcessedNotification,
        ServiceItems: this.refundRequestForm.value.ServiceItems,
        RefundServiceItems: this.refundRequestForm.value.RefundServiceItems,
        Comment: this.refundRequestForm.value.Comment,
        CustomerId: this.refundRequestForm.value.CustomerId,
        RefundRequestGUID: this.refundRequestForm.value.RefundRequestGUID,
      },
    })

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //this.refundRequestForm.value.AFSTransactionId = result;
    });
  }

  goBack() {
    this.tableData = this.paymentService.getTableData();
    this.location.back();
  }

  //get payment data
  getPaymentDetailsByID() {
    this.isLoading = true;
    this.paymentService.PaymentDetailsByID(this.route.snapshot.params.paymentRequestId)
      .subscribe((response: any) => {
        this.afsTransactionId = response['requestData'].transactionId;
        this.getRefundByid();
        this.refundData = response;
        const dataToSend = response['authorizationHistory'] == 0 ? '' : response['authorizationHistory'][0]['chargeAmt'];
        this.paymentService.sendData(dataToSend);
        this.refundRequestForm.patchValue({
          CustTrackingNo: response['requestData']['trackingNumber'],
          AFSTransactionId: response['requestData']['transactionId'],
          CustomerId: response['providerData']['customerNumber']
        });
        console.log(response);
        this.transactionDetailsForm = new FormGroup(
          {
            serviceType: new FormControl('B'),
            lender: new FormControl(response['providerData']['lender'] == null ? '' : response['providerData']['lender']),
            loanNum: new FormControl(response['requestData']['loanNumber'] == null ? '' : response['requestData']['loanNumber']),
            trackingNum: new FormControl(response['requestData']['trackingNumber'] == null ? '' : response['requestData']['trackingNumber']),
            borrower: new FormControl(response['cardData'] == null ? '' : response['cardData']['borrowerLastName']),
            property: new FormControl(response['requestData'] == null ? '' : response['requestData']['propertyAddress']),
            serviceItems: new FormControl(''),
            serviceCharge: new FormControl(response['authorizationHistory'][0] == null ? '' : response['authorizationHistory'][0]['chargeAmt']),
            ActualSettlement: new FormControl(response['authorizationHistory'][0] == null ? '' : response['authorizationHistory'][0]['chargeAmt']),
            orderDate: new FormControl(this.datePipe.transform(response['requestData']['orderDate'], 'M/d/yyyy')),
            settleDate: new FormControl(response['settleHistory'][0] == null ? '' : response['settleHistory'][0]['formattedSettleDate']),
            completionDate: new FormControl(response['requestData']['formattedCompletionDate'] == null ? '' : response['requestData']['formattedCompletionDate']),
            cancelDate: new FormControl(response['requestData']['canceledDate'] == null ? '' : this.datePipe.transform(response['requestData']['canceledDate'], 'MM/dd/yyyy')),
            refund: new FormControl(response['paymentData']['refundAmount'] == null ? '' : response['paymentData']['refundAmount']),
            refundDate: new FormControl(''),
            remitDate: new FormControl(response['paymentData']['formattedRemitDate'] == null ? '' : response['paymentData']['formattedRemitDate']),
            afsPaymentStatus: new FormControl(response['requestData']['afsPaymentStatus'] == null ? '' : response['requestData']['afsPaymentStatus'])
          })
        this.isLoading = false;
      })
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getRefundByid();
  }

  //get refund by trans ID
  getRefundByid() {
    this.isLoading = true;
    var refundrequestData = {
      pageIndex: this.pageIndex + 1,
      pageSize: this.pageSize,
      customerId: this.customerId,
      AFSTransactionId: this.afsTransactionId
    }
    this.refundService.getRefund(refundrequestData).subscribe((response: any) => {
      console.log(response);
      this.refundAmount = response.totalRefundCount;
      const refundDataToSend = response.totalRefundCount;
      this.refundService.sendRefundAmount(refundDataToSend);
      this.totalAmount = response.totalRefundCount;
      this.refundData = response.refundRequests;
      this.dataSource = this.refundData;
      this.totalCount = response.totalCount;
      this.isRefund = response.refundRequests[response.refundRequests.length - 1].isRefunded;
      this.isCancelled = response.refundRequests[response.refundRequests.length - 1].isCancelled;
      this.refundAttempts = response.refundRequests[response.refundRequests.length - 1].refundAttempts;
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
      console.log(error);
    })
  }

  //cancel refund
  cancelRefund(refundRequestId: number) {
    const dialogRef = this.dialog.open(CancelRefundComponent, {
      maxWidth: 'auto',
      width: '550px',
      height: 'auto',
      disableClose: true,
      data: { refundRequestId: refundRequestId }
    });
  }

  //get refund by id
  getRefundDetailsById(refundRequestId: any) {
    this.isLoading = true;
    this.refundService.getRefundDetailsById(refundRequestId).subscribe((response: any) => {
      console.log(response);
      const dialogRef = this.dialog.open(RefundRequestDetailsComponent, {
        width: '700px',
        height: 'auto',
        disableClose: true,
        data: {
          lenderName: response.lenderName,
          vendorId: response.vendorId,
          borrower: response.partyName,
          loanId: response.loanNumber,
          property: response.property,
          authPnRef: response.authRef,
          refundPnRef: response.pnrefCode,
          refundAmt: response.refundAmount,
          refundRequestId: response.refundRequestId,
          custTrackingNo: response.custTrackingNo
        }
      });
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      console.log(err);
    })
  }

  toggleRemitRow(element: RemittanceResponse) {
    element.remittedPayments && (element.remittedPayments as MatTableDataSource<RemittedPayments>)
      .data.length ? (this.expandedRemit = this.expandedRemit === element ? null : element) : null;
    this.cd.detectChanges();
    this.innerRemitTables.forEach((table, index) => (table.dataSource as MatTableDataSource<RemittedPayments>).sort = this.innerRemitSort.toArray()[index]);
  }

  applyRemitFilter(filterValue: string) {
    this.innerRemitTables.forEach(
      (table, index) =>
      ((table.dataSource as MatTableDataSource<RemittedPayments>).filter = filterValue
        .trim()
        .toLowerCase())
    );
  }

  onRemittanceSearch() {
    this.isLoading = true;
    const custId = "589f3998-6efc-4968-bebc-79d5ea8f1f68"
    this.paymentService.getRemittanceDetails(
      this.pageSize,
      this.pageIndex,
      this.customerId,
      this.route.snapshot.params.paymentRequestId
      // custId,
      // 260
    ).subscribe((response: any) => {
      console.log("remit", response);
      this.remitApiResponse = response;
      this.remitApiResponse.forEach((user) => {
        if (user.remittedPayments['pagedPaymentByLender'] && Array.isArray(user.remittedPayments['pagedPaymentByLender']) && user.remittedPayments['pagedPaymentByLender'].length) {
          this.remitData = [...this.remitData, { ...user, remittedPayments: new MatTableDataSource(user.remittedPayments['pagedPaymentByLender']) }];
        } else {
          this.remitData = [...this.remitData, user];
        }
        console.log(user.remittedPayments['pagedPaymentByLender'])
      });
      this.remitDataSource = new MatTableDataSource(this.remitData);
      console.log("re", this.remitData)
      this.remitDataSource.paginator = this.remitPaginator;
      this.remitDataSource.sort = this.Remitsort;
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      console.log(err);
    })
  }

  onRemitPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.onRemittanceSearch();
  }
}

